import { Form, Button, Checkbox, List, Card } from 'antd';
import { default as React } from 'react';
import { donationOptionsText, donationOptionsMandatory, excludedOptions } from '../donationFlow/DataDonationOptions'
import { CloseOutlined, WarningOutlined } from '@ant-design/icons';
import '../../styles/Stepper.css';

const getDefaults = () => {
    const defaults = {};
    // Loop through mandatory and text options to set defaults
    [...donationOptionsMandatory, ...donationOptionsText].forEach(item => {
        defaults[item.name] = item.essential; 
    });
    return defaults;
};


export const FormDonationOptions = ({ next, prev, platform, donationOptions, payingParticipants, setDonationOptions, donationOptionsSet, setDonationOptionsSet }) => {

    //console.log("platform: ", platform);

    // Expects a form's values
    const onFinish = (values) => {
        //console.log(values);
        setDonationOptions(values);
        setDonationOptionsSet(true);
        next();
    };

    // Expects a form's values. Returns a boolean.
    // Used when one donation option is reliant on another such as with comments
    function getParentValues(values, parent) {
        switch (parent) {
            case "Comments":
                return values.Comments;
        }
    };

    function getCheckbox(name, title, description, optionPlatform, essential, payment, use, warning, horizontal, vertical, useMobileVersion) {
        return (
            <Form.Item
                name={name}
                hidden={!(optionPlatform === "all" || optionPlatform === platform)}
                valuePropName="checked"
                //initialValue={essential ? true : false}
            >
                <Checkbox
                    value={name}
                    disabled={essential}
                >
                    <List.Item
                        className={useMobileVersion ? horizontal : vertical}
                        extra={payingParticipants? payment : ""}>
                        <List.Item.Meta
                            title={title}
                            description={<div>{description}<br /><br />{use}<br /><br /><WarningOutlined className="WarningIcon" hidden={(warning === null)} />{warning}</div>}
                        />
                    </List.Item>
                </Checkbox>
            </Form.Item>
        )
    }

    function ExcludedItem({ title, description, exlusionPlatform }) {
        return (
            <List.Item hidden={!(exlusionPlatform === "all" || exlusionPlatform === platform)}>
                <List.Item.Meta
                    title={<div><CloseOutlined className="redX" />{title}</div>}
                    description={description}
                />
            </List.Item>
        )
    }

    function DonationOption({ name, title, description, optionPlatform, essential, payment, type, parent, use, warning }) {
        // dynamically select a component from componentMapping object
        if (type === "standard") {
            return (
                getCheckbox(name, title, description, optionPlatform, essential, payment, use, warning, 'DonationOptionHorizontal', 'DonationOptionVertical')
            )
        }
        return (
            <Form.Item
                hidden={!(optionPlatform === "all" || optionPlatform === platform)}
                shouldUpdate={(prevValues, currentValues) => getParentValues(prevValues, parent) !== getParentValues(currentValues, parent)}
                className="SecondaryCheckbox"
            >
                {({ getFieldValue }) =>
                    (!(getFieldValue(parent) === false)) ? (
                        getCheckbox(name, title, description, optionPlatform, essential, payment, use, warning, 'DonationOptionHorizontalSecondary', 'DonationOptionVerticalSecondary')
                    ) : false
                }
            </Form.Item>
        )
    }

    return (
        <div align="center">
            <Form
                name="Options"
                // Use existing state if set, otherwise calculate defaults 
                initialValues={donationOptionsSet ? donationOptions : getDefaults()}
                onFinish={onFinish}>
                <Card className="standardCard">
                    {donationOptionsMandatory.map((item) => (
                        <DonationOption key={item.name} {...item} />
                    ))}
                </Card>,
                <Card>
                    {donationOptionsText.map((item) => (
                        <DonationOption key={item.name} {...item} />
                    ))}
                </Card>,
                <Card className="donationCardExcluded">
                    <List>
                        {excludedOptions.map((item) => (
                            <ExcludedItem key={item.name} {...item} />
                        ))}
                    </List>
                </Card>,
                <Form.Item>
                    <Button
                        type="button"
                        className="RightMargin"
                        onClick={prev}
                        disabled={true}>
                        Previous
                    </Button>
                    <Button
                        type="primary"
                        htmlType="submit">
                        Next
                    </Button>
                </Form.Item>
            </Form >
        </div>
    )
};

export default FormDonationOptions;